import React, {
    useState,
    useEffect,

} from "react"
import { Checkbox } from './ot'

const BaseCardView1_1 = ({
    checked,
    onCheckedChange = () => { }
}, ref) => {
    return (
        <div className="absolute top-2 left-2 z-10">
            <Checkbox
                checked={checked}
                onCheckedChange={onCheckedChange}
            />
        </div>
    )
}

export default BaseCardView1_1
